<mat-dialog-content class="mat-typography" [ngClass]="data.customCssClass">
  <h3 class="dialog-title">{{data.dialogTitle}}</h3>
  <p class="dialog-text" [ngClass]="{'full': showTechnicalDescription}">{{getCurrentDescription()}}</p>

  <div class="action-btn-wrapper" fxLayout="row" [ngClass]="{'second-btn-active': data.secondButtonText}" [fxLayoutAlign]="data.singleButton ? 'center center' : 'space-between center'">

      <!-- Left Button (Decline/Back) -->
      <button *ngIf="!data.singleButton" class="back-btn" [mat-dialog-close]="false" >
        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="web-btn-text">{{data.declineBtnText}}</span>
      </button>

      <!-- Center Button (Confirm/Approve) -->
      <button class="confirm-btn" [mat-dialog-close]="true">
        <span>{{data.confirmBtntext}}</span>
      </button>

      <!-- Details button for technical description toggle -->
      <button *ngIf="data.technicalDescription" class="options-web-btn" (click)="toggleTechnicalDescription()">
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="3" cy="10.5" r="2" fill="white" />
          <circle cx="11" cy="10.5" r="2" fill="white" />
          <circle cx="19" cy="10.5" r="2" fill="white" />
        </svg>
        <span  class="web-btn-text" >Details</span>
      </button>

      <!-- Right Spacer (Hidden) or Second Action Button -->
      <!-- Standard Hidden Spacer -->
      <button *ngIf="!data.singleButton && !data.secondButtonText" class="back-btn" [hidden]="true" style="visibility: hidden;">
        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="web-btn-text">{{data.declineBtnText}}</span>
      </button>

      <!-- Second Action Button (e.g. Reject) -->
      <button *ngIf="data.secondButtonText" class="back-btn" [mat-dialog-close]="'reject'">
        <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M1 3L13 15M13 3L1 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="web-btn-text">{{data.secondButtonText}}</span>
      </button>
  </div>
</mat-dialog-content>
